import { graphql } from '@/gql';
import type { ClearUserOfFraudSuspicionMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const clearUserOfFraudSuspicion = async ({
  phoneNumber,
  unflaggedReason,
}: ClearUserOfFraudSuspicionMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation clearUserOfFraudSuspicion($phoneNumber: String!, $unflaggedReason: String) {
        clearUserOfFraudSuspicion(phoneNumber: $phoneNumber, unflaggedReason: $unflaggedReason)
      }
    `),
    variables: {
      phoneNumber,
      unflaggedReason,
    },
  });

  return response.data?.clearUserOfFraudSuspicion ?? false;
};
